import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { FileText, Building2, CreditCard, Calendar, XCircle, AlertTriangle, Scale, Wrench } from 'lucide-react';
export const Terms = () => {
  return <div className="min-h-screen bg-slate-50" style={{
    width: '100%'
  }} data-id="element-723">
      <Helmet data-id="element-724">
        <title data-id="element-725">Terms & Conditions | Taskpoint Appliance Repairs</title>
        <meta name="description" content="Terms and conditions for Taskpoint appliance repair services. Professional UK washing machine engineer and domestic appliance diagnostics with clear service terms." data-id="element-726" />
        <meta name="keywords" content="appliance repair terms, washing machine engineer UK, service conditions, domestic appliance diagnostics, same-day repair service, professional engineer" data-id="element-727" />
      </Helmet>
      <Header data-id="element-728" />
      <section className="py-20 bg-gradient-to-br from-teal-600 to-cyan-700 text-white" data-id="element-729">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-730">
          <h1 className="text-5xl font-bold mb-6" data-id="element-731">Terms & Conditions</h1>
          <p className="text-xl text-teal-50 max-w-3xl" data-id="element-732">
            Service terms for our appliance repair business
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-733">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-734">
          <div className="bg-white rounded-xl shadow-lg p-8 md:p-12" data-id="element-735">
            <div className="space-y-8" data-id="element-736">
              <div data-id="element-737">
                <div className="flex items-center space-x-3 mb-4" data-id="element-738">
                  <FileText className="w-8 h-8 text-teal-600" data-id="element-739" />
                  <h2 className="text-3xl font-bold text-slate-800" data-id="element-740">
                    Overview
                  </h2>
                </div>
                <p className="text-slate-600 leading-relaxed" data-id="element-741">
                  This website is operated by Taskpoint. By using this site or
                  purchasing our services, you accept these Terms & Conditions.
                </p>
              </div>
              <div data-id="element-742">
                <div className="flex items-center space-x-3 mb-4" data-id="element-743">
                  <Building2 className="w-8 h-8 text-teal-600" data-id="element-744" />
                  <h2 className="text-3xl font-bold text-slate-800" data-id="element-745">
                    Company Information
                  </h2>
                </div>
                <div className="text-slate-600 space-y-2" data-id="element-746">
                  <p data-id="element-747">
                    <strong data-id="element-748">Taskpoint</strong>
                  </p>
                  <p data-id="element-749">112-116 The Broadway, London, NW7 3TB</p>
                  <p data-id="element-750">
                    📧{' '}
                    <a href="mailto:Benjobalolong082@gmail.com" className="text-teal-600 hover:underline break-all" data-id="element-751">
                      Benjobalolong082@gmail.com
                    </a>
                  </p>
                  <p data-id="element-752">
                    📞{' '}
                    <a href="tel:08000554969" className="text-teal-600 hover:underline" data-id="element-753">
                      0800 055 4969
                    </a>
                  </p>
                </div>
              </div>
              <div data-id="element-754">
                <div className="flex items-center space-x-3 mb-4" data-id="element-755">
                  <Wrench className="w-8 h-8 text-teal-600" data-id="element-756" />
                  <h2 className="text-3xl font-bold text-slate-800" data-id="element-757">
                    Our Services
                  </h2>
                </div>
                <p className="text-slate-600 leading-relaxed mb-4" data-id="element-758">
                  We provide domestic appliance diagnostics, repair, and
                  maintenance services only. Our services include:
                </p>
                <ul className="space-y-2 text-slate-600" data-id="element-759">
                  <li className="flex items-start space-x-2" data-id="element-760">
                    <span className="text-teal-600 mt-1" data-id="element-761">•</span>
                    <span data-id="element-762">
                      Engineer callouts and on-site diagnostics (fee earned once
                      carried out)
                    </span>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-763">
                    <span className="text-teal-600 mt-1" data-id="element-764">•</span>
                    <span data-id="element-765">
                      Repair work with parts quotes approved before fitting
                    </span>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-766">
                    <span className="text-teal-600 mt-1" data-id="element-767">•</span>
                    <span data-id="element-768">Preventative maintenance visits</span>
                  </li>
                </ul>
                <p className="text-slate-600 mt-4" data-id="element-769">
                  Full details and pricing are displayed on our service pages.
                </p>
              </div>
              <div data-id="element-770">
                <div className="flex items-center space-x-3 mb-4" data-id="element-771">
                  <CreditCard className="w-8 h-8 text-teal-600" data-id="element-772" />
                  <h2 className="text-3xl font-bold text-slate-800" data-id="element-773">
                    Pricing & Payment
                  </h2>
                </div>
                <p className="text-slate-600 leading-relaxed" data-id="element-774">
                  All prices are in GBP. Payment is processed securely via
                  Stripe. You will receive an email confirmation after payment
                  is completed.
                </p>
              </div>
              <div data-id="element-775">
                <div className="flex items-center space-x-3 mb-4" data-id="element-776">
                  <Calendar className="w-8 h-8 text-teal-600" data-id="element-777" />
                  <h2 className="text-3xl font-bold text-slate-800" data-id="element-778">
                    Service Start & Duration
                  </h2>
                </div>
                <p className="text-slate-600 leading-relaxed" data-id="element-779">
                  Your service begins when payment is confirmed and runs for the
                  stated term (e.g., 12 months from purchase date).
                </p>
              </div>
              <div data-id="element-780">
                <div className="flex items-center space-x-3 mb-4" data-id="element-781">
                  <FileText className="w-8 h-8 text-teal-600" data-id="element-782" />
                  <h2 className="text-3xl font-bold text-slate-800" data-id="element-783">
                    Workmanship Assurance
                  </h2>
                </div>
                <p className="text-slate-600 leading-relaxed" data-id="element-784">
                  We stand behind our work. If the same fault reoccurs within 90
                  days due to our workmanship, we will return to address it at
                  no additional charge.
                </p>
              </div>
              <div data-id="element-785">
                <div className="flex items-center space-x-3 mb-4" data-id="element-786">
                  <XCircle className="w-8 h-8 text-teal-600" data-id="element-787" />
                  <h2 className="text-3xl font-bold text-slate-800" data-id="element-788">
                    Cancellations & Refunds
                  </h2>
                </div>
                <ul className="space-y-2 text-slate-600" data-id="element-789">
                  <li className="flex items-start space-x-2" data-id="element-790">
                    <span className="text-teal-600 mt-1" data-id="element-791">•</span>
                    <span data-id="element-792">0-14 days: Full refund if no work completed</span>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-793">
                    <span className="text-teal-600 mt-1" data-id="element-794">•</span>
                    <span data-id="element-795">15-28 days: Partial refund at our discretion</span>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-796">
                    <span className="text-teal-600 mt-1" data-id="element-797">•</span>
                    <span data-id="element-798">After 28 days: No refunds available</span>
                  </li>
                </ul>
              </div>
              <div data-id="element-799">
                <div className="flex items-center space-x-3 mb-4" data-id="element-800">
                  <AlertTriangle className="w-8 h-8 text-teal-600" data-id="element-801" />
                  <h2 className="text-3xl font-bold text-slate-800" data-id="element-802">
                    Service Exclusions
                  </h2>
                </div>
                <p className="text-slate-600 leading-relaxed mb-4" data-id="element-803">
                  Our services do not cover:
                </p>
                <ul className="space-y-2 text-slate-600" data-id="element-804">
                  <li className="flex items-start space-x-2" data-id="element-805">
                    <span className="text-teal-600 mt-1" data-id="element-806">•</span>
                    <span data-id="element-807">Pre-existing faults before service start</span>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-808">
                    <span className="text-teal-600 mt-1" data-id="element-809">•</span>
                    <span data-id="element-810">Misuse, neglect, or cosmetic-only issues</span>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-811">
                    <span className="text-teal-600 mt-1" data-id="element-812">•</span>
                    <span data-id="element-813">Unauthorised repair work by third parties</span>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-814">
                    <span className="text-teal-600 mt-1" data-id="element-815">•</span>
                    <span data-id="element-816">Non-standard modifications to appliances</span>
                  </li>
                  <li className="flex items-start space-x-2" data-id="element-817">
                    <span className="text-teal-600 mt-1" data-id="element-818">•</span>
                    <span data-id="element-819">Appliances not used per manufacturer guidelines</span>
                  </li>
                </ul>
              </div>
              <div data-id="element-820">
                <div className="flex items-center space-x-3 mb-4" data-id="element-821">
                  <FileText className="w-8 h-8 text-teal-600" data-id="element-822" />
                  <h2 className="text-3xl font-bold text-slate-800" data-id="element-823">
                    Your Responsibilities
                  </h2>
                </div>
                <p className="text-slate-600 leading-relaxed" data-id="element-824">
                  You must provide accurate booking information, safe access to
                  the appliance, and a safe working environment for our
                  engineers.
                </p>
              </div>
              <div data-id="element-825">
                <div className="flex items-center space-x-3 mb-4" data-id="element-826">
                  <Scale className="w-8 h-8 text-teal-600" data-id="element-827" />
                  <h2 className="text-3xl font-bold text-slate-800" data-id="element-828">
                    Liability
                  </h2>
                </div>
                <p className="text-slate-600 leading-relaxed" data-id="element-829">
                  We are not liable for indirect or consequential losses. Our
                  maximum liability is limited to the amount paid for the
                  current service term, except where the law prohibits such
                  limitation.
                </p>
              </div>
              <div data-id="element-830">
                <div className="flex items-center space-x-3 mb-4" data-id="element-831">
                  <AlertTriangle className="w-8 h-8 text-teal-600" data-id="element-832" />
                  <h2 className="text-3xl font-bold text-slate-800" data-id="element-833">
                    Force Majeure & Changes
                  </h2>
                </div>
                <p className="text-slate-600 leading-relaxed" data-id="element-834">
                  We are not liable for delays or failures due to events beyond
                  our reasonable control. These Terms may be updated; continued
                  use of our services implies acceptance of any changes.
                </p>
              </div>
              <div data-id="element-835">
                <div className="flex items-center space-x-3 mb-4" data-id="element-836">
                  <Scale className="w-8 h-8 text-teal-600" data-id="element-837" />
                  <h2 className="text-3xl font-bold text-slate-800" data-id="element-838">
                    Disputes & Governing Law
                  </h2>
                </div>
                <p className="text-slate-600 leading-relaxed" data-id="element-839">
                  Please contact us first to resolve any issues. These Terms are
                  governed by English law, and the courts of England & Wales
                  have exclusive jurisdiction.
                </p>
              </div>
              <div className="bg-teal-50 p-6 rounded-lg" data-id="element-840">
                <h3 className="font-semibold text-slate-800 mb-2" data-id="element-841">
                  Contact Us
                </h3>
                <p className="text-slate-600" data-id="element-842">
                  📧{' '}
                  <a href="mailto:Benjobalolong082@gmail.com" className="text-teal-600 hover:underline break-all" data-id="element-843">
                    Benjobalolong082@gmail.com
                  </a>
                </p>
                <p className="text-slate-600" data-id="element-844">
                  📞{' '}
                  <a href="tel:08000554969" className="text-teal-600 hover:underline" data-id="element-845">
                    0800 055 4969
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer data-id="element-846" />
    </div>;
};